import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";

export default function LibraryRequestKebabMenu({
  label = "Actions",
  disabled,
  onButtonClick,
  widthClass = "w-56",
  children,
}) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton
        aria-label={label}
        disabled={disabled}
        onClick={onButtonClick}
        className="inline-flex items-center justify-center rounded-md p-1.5 text-sm font-medium text-gray-400 hover:text-gray-500 disabled:cursor-wait disabled:opacity-60"
      >
        <EllipsisVerticalIcon className="h-5 w-5 flex-shrink-0" />
      </MenuButton>
      <MenuItems
        anchor="bottom end"
        portal
        className={`z-50 cursor-pointer mt-2 ${widthClass} max-h-96 overflow-y-auto rounded-md shadow-lg bg-white border border-1 ring-1 ring-black ring-opacity-5 focus:outline-none shadow-ring`}
      >
        <div className="py-1">{children}</div>
      </MenuItems>
    </Menu>
  );
}
